import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/faqs";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-surface px-5 py-16 sm:py-24" data-id="element-143" data-mp="usvtgc70ruy6">
      <div className="mx-auto max-w-3xl" data-id="element-144" data-mp="71zv0w8261hy">
        <SectionHeading eyebrow="Frequently Asked Questions" title="Everything You Need to Know" data-id="element-145" data-mp="731hrxyfscfi" />

        <div className="mt-10 space-y-3" data-id="element-146" data-mp="24hx00vkx6oq">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-147" data-mp="c01mo5jjv951" data-mpi={i}>
                <h3 data-id="element-148" data-mp="1sdrtvl5yudiw">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-start justify-between gap-4 p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" data-id="element-149" data-mp="1sd8ae00o3h2r">
                    <span className="text-base font-extrabold leading-snug text-ink" data-id="element-150" data-mp="rsomx2ahvxs9">
                      {i + 1}. {item.q}
                    </span>
                    <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-151" data-mp="3v95gkwdyg26q" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-152" data-mp="cue8t6utcj2z">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-153" data-mp="3ci491jyrqybk">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink-muted" data-id="element-154" data-mp="ipd3gz7qksot">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCta label="I'm Ready — Give Me the Blueprint" data-id="element-155" data-mp="sibt8keyypa0" />
      </div>
    </section>;
}